









































































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { WorkflowCommonMixin } from "../mixins";
import { ReceptionReferenceKinds } from "../../../domain/workflow/kinds";
import { ReceptionCommentDispInfo, ReceptionReference } from "../../../domain/workflow/reference";

import ReceptionTab from "./tabs/ReceptionTab.vue";
import DocumentTab from "./tabs/DocumentTab.vue";
import WorkflowReferenceTab from "./tabs/WorkflowReferenceTab.vue";
import RequestSheetTab from "./tabs/RequestSheetTab.vue";
import DetailHistoryTab from "./tabs/DetailHistoryTab.vue";
import ManagersHistoryTab from "./tabs/ManagersHistoryTab.vue";
import WorkflowActionDialog from "../dialogs/WorkflowActionDialog.vue";
import WorkflowActionConfirmDialog from "../dialogs/WorkflowActionConfirmDialog.vue";

@Component({
  components: {
    ReceptionTab,
    DocumentTab,
    WorkflowReferenceTab,
    RequestSheetTab,
    DetailHistoryTab,
    ManagersHistoryTab,
  }
})
export default class ReceptionContent extends Mixins(WorkflowCommonMixin) {
  // @Model("input")
  // value: ReceptionReference;

  @Prop()
  reference: ReceptionReference;

  @Prop()
  isShowPreview: boolean;

  @Prop()
  isAdmin: boolean;

  @Prop({ default: ReceptionReferenceKinds.Document })
  defaultDisplayKind: ReceptionReferenceKinds;

  @Prop()
  commentSetting: ReceptionCommentDispInfo;

  @Prop()
  workflowActionDialog: WorkflowActionDialog;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  @Prop()
  isSendBackAndEditButtonEnable: boolean;

  @Prop({ default: false })
  isReadOnly: boolean;

  @Emit()
  deletedReceptionDetail(): void {}

  @Emit()
  doActionReceptionDetail(): void {}

  @Emit()
  requestSheetDeleted(): void {}

  // 詳細削除通知が来ました
  onDetailDeleted(): void {
    console.log("onDetailDeleted");
    // 親に通知します
    this.deletedReceptionDetail();
  }

  // WF実行通知が来ました
  onDoActioned(): void {
    console.log("onDoActioned");
    // 親に通知します
    this.doActionReceptionDetail();
  }

  // 依頼書削除通知が来ました
  onRequestSheetDeleted() {
    console.log("onRequestSheetDeleted");
    // 親に通知します
    this.requestSheetDeleted();
  }

  onStartedDoAction() {
    console.log("onStartedDoAction");
    this.isDoActionLoading = true;
  }

  onStopedDoAction() {
    console.log("onStopedDoAction");
    this.isDoActionLoading = false;
  }



  data(): any {
    return {
      displayKind: this.defaultDisplayKind,
      isDoActionLoading: false,
    };
  }
  displayKind: ReceptionReferenceKinds;
  isDoActionLoading: boolean;

  created(): void {
    // if (!this.isAdmin) {
    // this.showDocumentTab(); 
    // }
  }

  mounted() {}

  get isRequestSheetEnable(): boolean {
    return this.reference ? (this.reference.requestSheetFormats.length !== 0 || !!this.reference.requestSheetDocument) : false;
  }

  get isDetailVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.Detail;
  }

  get isDocumentVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.Document;
  }

  get isWorkflowVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.Workflow;
  }

  get isRequestSheetVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.RequestSheet;
  }

  get isDetailHistoryVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.DetailHistory;
  }

  get isManagerHistoryVisible(): boolean {
    return this.displayKind === ReceptionReferenceKinds.ManagerHistory;
  }

  get isUnmanaged(): boolean {
    return this.reference && this.reference.document && this.reference.document.isUnmanaged;
  }

  showDetailTab(): void {
    this.displayKind = ReceptionReferenceKinds.Detail;
  }

  showDocumentTab(): void {
    this.displayKind = ReceptionReferenceKinds.Document;
  }

  showWorkflowTab(): void {
    this.displayKind = ReceptionReferenceKinds.Workflow;
  }

  showRequestSheetTab(): void {
    this.displayKind = ReceptionReferenceKinds.RequestSheet;
  }

  showDetailHistoryTab(): void {
    this.displayKind = ReceptionReferenceKinds.DetailHistory;
  }

  showManagerHistoryTab(): void {
    this.displayKind = ReceptionReferenceKinds.ManagerHistory;
  }

  @Watch("defaultDisplayKind")
  onDefaultDisplayKindChanged(newValue: ReceptionReferenceKinds, oldValue: ReceptionReferenceKinds) {
    this.displayKind = newValue;
  }
}
